const planningSteps = ['foundation', 'external-assessment', 'internal-assessment', 'formulation'];

export type CompanyWorkspaceSection =
  | 'overview'
  | 'context'
  | 'ai-plan'
  | 'strategy'
  | 'people'
  | 'execution'
  | 'reports'
  | 'settings';

export function getCompanyWorkspaceSection(pathname: string): CompanyWorkspaceSection {
  const suffix = pathname.replace(/^\/company\/[^/]+\/?/, '');
  if (suffix === 'strategy' || suffix.startsWith('strategy/')) return 'strategy';
  if (suffix === 'organization' || suffix === 'org-chart') return 'people';
  if (suffix === 'execution') return 'execution';
  if (suffix === 'visual-report') return 'reports';
  if (suffix === 'admin') return 'settings';
  if (suffix === 'context') return 'context';
  if (suffix === 'ai-plan') return 'ai-plan';
  return 'overview';
}

// Preserve only shared sections: company-specific project or strategy IDs cannot be carried over.
export function getCompanySwitchPath(pathname: string, companyId: string, hash = '') {
  const suffix = pathname.replace(/^\/company\/[^/]+\/?/, '');
  const parts = suffix.split('/');
  if (
    [
      'strategy',
      'organization',
      'org-chart',
      'execution',
      'visual-report',
      'admin',
      'context',
      'ai-plan',
    ].includes(suffix) ||
    (parts[0] === 'strategy' && planningSteps.includes(parts[1]) && parts.length <= 3)
  ) {
    const allowedHashes =
      suffix === 'strategy/external-assessment'
        ? ['#pestel', '#fiveForces', '#competitors', '#drivingForces']
        : suffix === 'strategy/internal-assessment'
          ? ['#swot', '#industrySuccessFactors']
          : [];
    return `/company/${companyId}/${suffix}${allowedHashes.includes(hash) ? hash : ''}`;
  }
  return `/company/${companyId}`;
}
